import MswWidgetCard from './msw-widget-card.vue';
import MswRegisterWidget from './msw-register-widget.vue';
import MswLicensestatusWidget from './msw-licensestatus-widget.vue';
import MswUsermgmtWidget from './msw-usermgmt-widget.vue';
import MswSupportcasesWidget from './msw-supportcases-widget.vue';
import MswDownloadsWidget from './msw-downloads-widget.vue';
import MswContemporaryWidget from './msw-contemporary-widget.vue';
import MswProductmgmtWidget from './msw-productmgmt-widget.vue';
export {
    MswWidgetCard,
    MswRegisterWidget,
    MswLicensestatusWidget,
    MswUsermgmtWidget,
    MswSupportcasesWidget,
    MswDownloadsWidget,
    MswContemporaryWidget,
    MswProductmgmtWidget,
};
export default {
  MswWidgetCard,
  MswRegisterWidget,
  MswLicensestatusWidget,
  MswUsermgmtWidget,
  MswSupportcasesWidget,
  MswDownloadsWidget,
  MswContemporaryWidget,
  MswProductmgmtWidget,
};
